import React, { Fragment } from 'react';
import Breadcrumb from '../Navigation/Breadcrumbs/Breadcrumb';
import { BreadcrumbLink } from '../Navigation/Breadcrumbs/BreadcrumbLink';

const EditBillingDetailsBreadcrumb = () => {

    return (
        <Breadcrumb>
            <Fragment>
                <BreadcrumbLink
                    label="Abo & Rechnung"
                    path="/account/subscription"
                    icon="settings"
                />
                <BreadcrumbLink
                    label="Zahlungsdetails bearbeiten"
                    path="/account/subscription/edit/billingdetails"
                />
            </Fragment>
        </Breadcrumb>
    );
};

export default EditBillingDetailsBreadcrumb;

